import React, {useEffect, useState, useRef, useCallback} from 'react';

import Close from "../assets/Close.svg"
import styled, {css} from 'styled-components/macro'
import {AnimatePresence, motion} from "framer-motion";
import Spinner from "./Spinner";
import DatePicker from "./DatePicker";
import moment from "moment";

const CreateLoanButton = styled(motion.button)`    
    width: 25%;
    min-width: 90px;
    height: 30px;
    margin-top: 5px;
    margin-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    
    border: 1px solid #FAAD16;
    box-sizing: border-box;
    border-radius: 41px;
    background: transparent;
    color: #FAAD16;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 180%;
    
    cursor: pointer;
`


const Popup = styled(motion.div)`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.75);
    text-align: center;
    z-index: 3;
`

const PopupInner = styled(motion.div)`
    text-align: left;
    vertical-align: middle;
    position: absolute;
    max-width: 700px;
    width: 671px;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%);
    padding: 40px;
    z-index: 4;
    
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    
    text-align: center;


`

const PopupHeader = styled.div`
    width: 100%;
    height: 24px;
    font-size: 19px;
    left: calc(50% - 623px/2);
    top: calc(50% - 24px/2 - 10px);
    line-height: 24px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-transform: capitalize;
`

const CloseButton = styled.a`
    width: 24px;
    margin-left: auto;
    height: 24px;
    cursor: pointer;
`

const ContentArea = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 40px;    
`

const InputBoxContainer = styled.div`
    position: static;
    height: auto;
    top: 8px;
    margin-bottom: 20px;
`
const InputBoxLabel = styled.div`
    display: flex;
    flex-direction:row;
    align-items: center;
    padding-left: 5px;
    white-space: nowrap;
    position: relative;
    height: 20px;
    width: ${props => props.FixedWidth || "10%"}};
    left: 30px;
    top: 10px;
    font-weight: bold;
    
    background: #FFFFFF;
    ${props => props.overlapped && css`
        z-index: 5;
    `}
`

const Required = styled.div`
    font-size: 11px;
    line-height: 16px;

    color: #DA1414;

    opacity: 0.8;
`

const InputBox = styled.input`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    padding: 0px 15px;
    
    position: static;
    width: 95%;
    height: 48px;
    left: 0px;
    top: 0px;
    
    font-size: 16px;
    
    background: #FFFFFF;

    border: 1px solid #858C94;
    box-sizing: border-box;
    border-radius: 8px;
`

const BigInputBox = styled.textarea`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    padding: 15px 16px;
    
    position: static;
    width: 90%;
    height: 100px;
    left: 0px;
    top: 0px;
    
    font-size: 16px;
    background: #F4F6F9;
    border-radius: 8px;
    border: none;
    resize: none;    
    
    ${props => props.primary && css`
        width: 95%;
        background: #FFFFFF;
        border: 1px solid #858C94;
        box-sizing: border-box;
        border-radius: 8px;
    `}
`

const PopupFooter = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 40px;

`

const PopupButton = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    
    position: relative;
    width: 300px;
    height: 42px;
    margin: 15px;
    background: transparent;
    color: #FAC44E;
    border: 2px solid #FAC44E;

    border-radius: 30px;
    ${props => props.primary && css`
        background: #FAC44E;
        color: white;
    `}
    
    cursor: pointer;
`

const SelectBox = styled.select`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    padding: 14px 15px;
    
    position: static;
    width: 95%;
    height: 48px;
    left: 0px;
    top: 0px;
    
    font-size: 16px;
    
    background: #FFFFFF;

    border: 1px solid #858C94;
    box-sizing: border-box;
    border-radius: 8px;
    
    option {
        color: black;
        background: white;
        display: flex;
        white-space: pre;
        min-height: 35px;
        
        padding: 14px 15px;

  }
`

const NotificationBox = styled.div`
    background: rgba(250, 173, 22, 0.1);
    border-radius: 6px;
    
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 90%;
    
    padding: 15px 16px;

    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    
    text-align: left;    
`

const WrapUpBox = styled.div`
    width: 100%;
    word-wrap: break-word;
`

const modalVariant = {
    initial: { opacity: 0 },
    isOpen: { opacity: 1 },
    exit: { opacity: 0 }
};
const containerVariant = {
    initial: { top: "-50%", transition: { type: "spring" } },
    isOpen: { top: "50%" },
    exit: { top: "-50%" }
};

const CreateLoanModal = (props) => {
    const [modal, setModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const loanPoolID = useState(props.loanPool.loanPoolID);
    const [developerID, setDeveloperID] = useState(0);
    const [landList, setLandList] = useState([]);
    const [landID, setLandID] = useState(0);
    const [collateral, setCollateral] = useState();
    const [loanAmount, setLoanAmount] = useState(0);
    const maturity = useRef(null);
    const [projectDescription, setProjectDescription] = useState("");

    const toggle = () => {
        if(props.developerInfos !== [] && typeof props.developerInfos !== "undefined" && props.developerInfos !== null && props.developerInfos.length !== null) {
            try {
                setDeveloperID(props.developerInfos[0].developerID)
            }
            catch(e) {
                window.location.reload();
            };
        }
        setLoading(false);
        setModal(!modal);
    };

    const loadLandList = useCallback((developerID) => {
        const selectedDeveloper = props.developerInfos.find(e => developerID === e.developerID);
        if (selectedDeveloper !== undefined && selectedDeveloper.landInfo.length !== 0) {
            setLandList(selectedDeveloper.landInfo);
            setLandID(selectedDeveloper.landInfo[0].landID);
        } else {
            setLandList([]);
            setLandID(0);
            setCollateral();
        }
    }, [developerID]);

    useEffect(() => {
        if (developerID !== 0) {
            loadLandList(developerID);
        }
    },[developerID]);

    useEffect(() => {
        if(landID !== 0) {
            loadCollateral(landID);
        }
    }, [landID]);

    const loadCollateral = useCallback((landId) => {
        if(landId !== 0) {
            const selectedLand = landList.find(e => e.landID.toString() === landId.toString());
            if(selectedLand !== undefined) {
                setCollateral(selectedLand);
            }
        }
    }, [landID]);

    return (
        <AnimatePresence>
            <CreateLoanButton
                key={"createLoanButton"}
                onClick={toggle}
                whileHover={{scale: 1.1}}
                whileTap={{scale: 0.9}}>
                CREATE LOAN
            </CreateLoanButton>
            {
                modal && (
                    <Popup
                        key={"popup-createLoan"}
                        initial={"initial"}
                        animate={"isOpen"}
                        exit={"exit"}
                        variants={modalVariant}
                    >
                        <PopupInner
                            key={"popupInner-createLOan"}
                            variants={containerVariant}>
                            <PopupHeader>
                                Create Loan
                                <CloseButton onClick={toggle}><img src={Close}/></CloseButton>
                            </PopupHeader>
                            { loading ? (<Spinner/>): (
                                <ContentArea>
                                    <InputBoxContainer>
                                        <InputBoxLabel FixedWidth={"19%"}>Select Developer<Required>*</Required></InputBoxLabel>
                                        <SelectBox onChange= {e => {
                                            setDeveloperID(e.target.value);
                                            loadLandList(e.target.value);
                                        }}
                                            required>
                                            {props.developerInfos.map((developer, index) => {
                                                return (<option value={developer.developerID} selected={developerID === developer.developerID} key={index}>{developer.companyName.toString()}</option>)
                                            })}
                                        </SelectBox>
                                    </InputBoxContainer>
                                    <InputBoxContainer>
                                        <InputBoxLabel FixedWidth={"19%"}>Select Collateral<Required>*</Required></InputBoxLabel>
                                        <SelectBox onChange= {e => {
                                            setLandID(e.target.value);
                                            loadCollateral(e.target.value);
                                        }} required>
                                            {landList.map((land, index) => {
                                                const landName = land.propertyAddress.length <= 50 ? land.propertyAddress : land.propertyAddress.toString().substring(0,50) + "...";
                                                return (<option value={land.landID} selected={landID === land.landID} key={index}>{land.propertyIdentificationNumber.toString() + " - " + landName.toString()}</option>)
                                            })}
                                        </SelectBox>
                                    </InputBoxContainer>
                                    <NotificationBox>
                                        Market: {props.loanPool.loanPoolName} has ${props.loanPool.poolReserve} liquidity <br/>
                                        {
                                            collateral === undefined ? "" : (
                                                <WrapUpBox>Collateral: {collateral.propertyAddress} <br/> available borrow limit is ${collateral.appraisalAmount * collateral.appraisalDiscountPercent / 100}<br/></WrapUpBox>
                                            )
                                        }
                                    </NotificationBox>
                                    <InputBoxContainer>
                                        <InputBoxLabel  FixedWidth={"11%"} overlapped>Maturity<Required>*</Required></InputBoxLabel>
                                        <DatePicker ref={maturity} />
                                    </InputBoxContainer>
                                    <InputBoxContainer>
                                        <InputBoxLabel FixedWidth={"15%"}>Loan Amount<Required>*</Required></InputBoxLabel>
                                        <InputBox
                                            type="number"
                                            onChange= {e => setLoanAmount(e.target.value)}
                                            min={0}
                                            max={collateral === undefined ? 0 : collateral.appraisalAmount * collateral.appraisalDiscountPercent}
                                            required/>
                                    </InputBoxContainer>
                                    <NotificationBox>
                                        Current borrowing rate is {props.loanPool.rateToBorrow}%
                                    </NotificationBox>
                                    <InputBoxContainer>
                                        <InputBoxLabel FixedWidth={"22%"}>Project Description<Required>*</Required></InputBoxLabel>
                                        <BigInputBox
                                        primary
                                        onChange={e => setProjectDescription(e.target.value)}
                                        />
                                    </InputBoxContainer>
                                </ContentArea>
                            )}
                            <PopupFooter>
                                <PopupButton onClick={toggle}>Cancel</PopupButton>
                                <PopupButton onClick={() => {
                                    setLoading(true);
                                    props.action(props.loanPool.loanPoolID, collateral.landID, loanAmount, maturity, projectDescription).catch(()=>{
                                        setLoading(false);
                                })}
                                } disabled={loanPoolID === undefined || collateral === undefined || loanAmount === 0 || maturity === undefined || developerID === 0 || collateral === undefined} primary>Withdraw Fund</PopupButton>
                            </PopupFooter>
                        </PopupInner>
                    </Popup>
                )
            }
        </AnimatePresence>
    );
};

export default CreateLoanModal;
